<template>
    <div class="page flex-col">
      <div class="find-route-detail-wrap flex-col">
        <div v-loading="loading" class="find-route-detail-wrap-in flex-col">
          <div class="top-nav-wrap flex-row justify-between">
            <div class="block_3 flex-col"></div>
            <div class="text-wrapper_2">
              <span class="text_8">{{$t('texts.contractResource')}}&nbsp;＞</span>
              <span class="text_9">{{$t('texts.viewPackageDetail')}}</span>
            </div>
          </div>
          <div class="search-top-bar flex-col">
            <div class="search-bar-wrap flex-row">
              <div class="search-bar-left flex-col justify-between">
                <span class="text_10">{{$t('texts.waybillNo')}}</span>
                <el-input
                  class="search-input"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  :placeholder="$t('placeholder.max50waybillNosAndSplit')"
                  v-model="textareaText"
                ></el-input>
              </div>
              <div @click="searchFunc" class="search-btn flex-col">
                <div class="search-btn-icon flex-col"></div>
              </div>
            </div>
            <div v-if="searchList.length" class="search-history flex-row justify-between">
              <div
                v-for="(item, idx) in searchList"
                :key="item"
                @click="() => addSearchBarHistoryItem(item)"
                class="search-history-item flex-row justify-between"
              >
                <span class="search-history-item-text">{{ item }}</span>
                <div
                  @click.stop="() => removeSearchItem(item, idx)"
                  class="search-history-item-close flex-col"
                ></div>
              </div>
            </div>
          </div>
          <div class="search-all-history flex-row justify-between">
            <span class="search-all-history-label">{{$t('texts.searchHistory')}}：</span>
            <div  class="search-history flex-row justify-between">
              <div
                v-for="item in historySearchOrders"
                :key="item"
                @click="() => addSearchBarHistoryItem(item)"
                class="search-history-item flex-row justify-between"
              >
                <span class="search-history-item-text">{{ item }}</span>
                <div
                  @click.stop="() => removeHistoryItem(item)"
                  class="search-history-item-close flex-col"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isSearch"
          v-for="(resultItem, resultItemIdx) in searchResultData"
          :key="resultItemIdx"
          class="result-item-box flex-col"
        >
          <div
            v-if="resultItem.trackingList && resultItem.trackingList.length"
            class="result-box-bar flex-col"
          >
            <div class="order-bar-wrap flex-row">
              <div class="  ">
                <div class="flex-row">
                  <span class="text_13">{{$t('texts.waybillNo')}}：</span>
                  <span class="text_15">{{ resultItem.waybillNo }}</span>
                </div>
                <div class="start-finished-wrap flex-row">
                  <span class="start-pointer">{{
                    resultItem.sourceLocation
                  }}</span>
                  <div class="arrow-icon flex-col"></div>
                  <span class="finished-pointer">{{
                    resultItem.destLocation
                  }}</span>
                </div>
              </div>
              <div class="order-bar-right-info flex-col justify-between">
                <span class="text_17">{{ resultItem.waybillStatusName }}</span>
                <span class="text_18">{{ resultItem.deliveredTime }}</span>
              </div>
            </div>
          </div>
  
          <div
            v-if="resultItem.trackingList && resultItem.trackingList.length"
            class="route-opt-list flex-col"
          >
            <div
              v-for="(resultOptItem, resultOptItemIdx) in resultItem.trackingList || []"
              :key="resultOptItemIdx"
              class="route-opt-item"
            >
              <div class="route-opt flex-row justify-between">
                <span class="route-opt-time">{{ resultOptItem.opTime }}</span>
              </div>
              <div class="text-route-opt-info-wrap">
                {{ resultOptItem.outerOpDesc }}
              </div>
            </div>
          </div>
  
          <div
            v-if="!resultItem.trackingList || !resultItem.trackingList.length"
            class="err-msg-wrap flex-col"
          >
            <span class="err-msg-text">
              {{$t('placeholder.sorryThisOrder{text}unFindPleaseCheck',{text:resultItem.waybillNo})}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { queryTracking } from '@/api';
  
  export default {
    setup() {
      const loading = ref(false);
      const isSearch = ref(false);
      const errMsg = ref('');
      const searchList = ref([]);
      const textareaText = ref('');
      const historySearchOrders = ref([]);
      const searchResultData = ref([]);
      const route = useRoute();
  
      // Fetch history from local storage
      const getHistoryOrderData = () => {
        let historySearchOrdersStr = window.localStorage.getItem("historySearchOrders");
        let historySearchOrders = [];
        if (historySearchOrdersStr) {
          try {
            historySearchOrders = JSON.parse(historySearchOrdersStr) || [];
          } catch (e) {
            console.log(e);
          }
        }
        return historySearchOrders;
      };
  
      // Set the local search history
      const setLocalHistory = () => {
        let historySearchOrders = getHistoryOrderData();
        let nowSearchArrs = textareaText.value.split(/\W/g);
        nowSearchArrs.forEach((orderText) => {
          if (orderText && !historySearchOrders.includes(orderText)) {
            historySearchOrders.unshift(orderText);
          }
        });
        historySearchOrders = historySearchOrders.slice(0, 10);
        window.localStorage.setItem("historySearchOrders", JSON.stringify(historySearchOrders));
        historySearchOrders.value = historySearchOrders;
      };
  
      // Handle search history item removal
      const removeSearchItem = (item, idx) => {
        searchList.value.splice(idx, 1);
        textareaText.value = searchList.value.join(",");
        searchFunc();
      };
  
      // Handle history removal
      const removeHistoryItem = (item) => {
        let historySearchOrders = getHistoryOrderData();
        historySearchOrders = historySearchOrders.filter(orderText => orderText !== item);
        window.localStorage.setItem("historySearchOrders", JSON.stringify(historySearchOrders));
        historySearchOrders.value = historySearchOrders;
      };
  
      // Add history item to the search bar
      const addSearchBarHistoryItem = (text) => {
        textareaText.value = text;
        searchFunc();
      };
  
      // Handle search
      const searchFunc = () => {
        searchList.value = [];
        searchList.value = textareaText.value ? textareaText.value.split(/\W/g).filter(o => !!o) : [];
        if (!searchList.value.length) {
          this.$message.error("請輸入包裹號");
          return;
        }
        loading.value = true;
        queryTracking({ documentCodes: searchList.value.join(",") })
          .then((res) => {
            loading.value = false;
            isSearch.value = true;
            setLocalHistory();
            if (res.success) {
              errMsg.value = "";
              searchResultData.value = res.data;
            } else {
              errMsg.value = res.msg;
            }
          });
      };
  
      onMounted(() => {
        historySearchOrders.value = getHistoryOrderData();
        if (route.query.searchStr) {
          textareaText.value = decodeURIComponent(route.query.searchStr);
          searchFunc();
        }
      });
  
      return {
        loading,
        isSearch,
        errMsg,
        searchList,
        textareaText,
        historySearchOrders,
        searchResultData,
        searchFunc,
        removeSearchItem,
        removeHistoryItem,
        addSearchBarHistoryItem,
      };
    },
  };
  </script>
  
  <style scoped>
  .page .flex-col{
    display: flex;
    flex-direction: column;
  }
  .page .flex-row{
    display: flex;
    flex-direction: row;
  }
.page {
 
  position: relative;
  

  overflow: hidden;
}

.find-route-detail-wrap {
  
}

.section_1 {
   
  height: 112px;
 
}

.group_1 {
  width: 1176px;
  height: 54px;
  margin: 29px 0 0 126px;
}

.label_1 {
  width: 43px;
  height: 35px;
  margin-top: 9px;
}

.text_1 {
  width: 108px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(0, 26, 75, 1);
  font-size: 18px;
  font-family: STYuanti-SC-Bold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 16px;
}

.text_2 {
  width: 36px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: right;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 262px;
}

.text_3 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 61px;
}

.section_2 {
  width: 14px;
  height: 14px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd491346d33754dbd9a600d436d1510f16e4110a76abf64257abf2cca875da7b5)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 19px 0 0 5px;
}

.text_4 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 52px;
}

.section_3 {
  width: 14px;
  height: 14px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge1f3341be40f2071d85bc1c417bfdf3f447b20beadba48e986944c9ed6e8a9ea)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 19px 0 0 5px;
}

.text_5 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 52px;
}

.section_4 {
  width: 14px;
  height: 14px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd491346d33754dbd9a600d436d1510f16e4110a76abf64257abf2cca875da7b5)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 19px 0 0 5px;
}

.text_6 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 52px;
}

.section_5 {
  width: 14px;
  height: 14px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd491346d33754dbd9a600d436d1510f16e4110a76abf64257abf2cca875da7b5)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 19px 0 0 5px;
}

.text-wrapper_1 {
  height: 54px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf3f10fe649adb281a0ed8e5c956c7c088657ee7b16d3253002684b72ae0b4641)
    100% no-repeat;
  background-size: 100% 100%;
  margin-left: 286px;
  width: 143px;
}

.text_7 {
  width: 92px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: center;
  white-space: nowrap;
  line-height: 25px;
  margin: 14px 0 0 26px;
}

.group_2 {
  width: 36px;
  height: 3px;
  margin: 1px 0 25px 814px;
}

.block_2 {
  width: 36px;
  height: 3px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6d23fd4ae54f05103db34c567702d70d3e22de7781868cd3a2444f89e3ec0928)
    100% no-repeat;
  background-size: 100% 100%;
}

.find-route-detail-wrap-in {
 
 
}

.top-nav-wrap {
  width: 1107px;
  height: 19px;
  margin: 20px auto 0;
  align-items: center;
  column-gap: 7px;
  justify-content: flex-start;
}

.block_3 {
  width: 19px;
  height: 19px;
  background: url(~/assets/send-gray.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.text-wrapper_2 {
  width: auto;
  height: 17px;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
}

.text_8 {
  width: auto;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 13px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
}

.text_9 {
  width: auto;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(77, 77, 77, 1);
  font-size: 13px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 17px;
}

.search-top-bar {
  box-shadow: 11px 24px 38px 0px rgba(0, 51, 102, 0.06);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 11px;
  width: 1107px;
 
  justify-content: flex-center;
  margin: 17px auto 0;
}

.search-bar-wrap {
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 11px;
 
  height: 127px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin: 19px;
}

.search-bar-left {
  flex: 1;

  margin: 23px 0 0 32px;
}

.text_10 {
  width: 65px;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 22px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 31px;
}

.search-input {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin-top: 7px;
}
.search-input :deep(.el-textarea__inner) {
  border: none;
  max-height: 43px;
  padding: 0;
  box-shadow: none;
}
.search-btn {
  background-color: rgba(44, 46, 45, 1);
  border-radius: 11px;
  height: 94px;
  width: 94px;
  margin: 16px 16px 0 0;
  cursor: pointer;
}
.search-btn:hover {
  background: #000;
}

.search-btn-icon {
  width: 27px;
  height: 27px;
  background: url(~/assets/search-icon.png)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 33px 0 0 33px;
}

.search-history {
  min-height: 27px;
  margin: 0 0 19px 50px;
  flex-wrap: wrap;
  gap: 7px;
  justify-content: flex-start;
}

.search-history-item {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 11px 9px 9px 9px;
  padding: 4px 7px;
  height: 27px;
  cursor: pointer;
  align-items: center;
}

.search-history-item-text {
  flex: 1;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 14px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 19px;
}

.search-history-item-close {
  width: 13px;
  height: 13px;
  background: url(~/assets/close-gray-icon.png)
    100% no-repeat;
  background-size: 100% 100%;
  margin-left: 7px;
}

.block_6 {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 14px 12px 12px 12px;
  width: 193px;
  height: 36px;
}

.image-text_2 {
  width: 175px;
  height: 25px;
  margin: 5px 0 0 10px;
}

.text-group_2 {
  width: 151px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.group_5 {
  width: 16px;
  height: 16px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
}

.search-all-history {
  min-height: 27px;
  margin: 18px auto;
  width: 945px;
  align-items: flex-start;
}
.search-all-history .search-history {
  flex: 1;
  margin: 0;
}
.search-all-history-label {
  width: 81px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 16px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-top: 2px;
}

.group_6 {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 14px 12px 12px 12px;
  width: 193px;
  height: 36px;
}

.image-text_3 {
  width: 175px;
  height: 25px;
  margin: 5px 0 0 10px;
}

.text-group_3 {
  width: 151px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(151, 161, 179, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.section_8 {
  width: 16px;
  height: 16px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng10d21fcd829d916c9925cebcbf7ec1fb1acf8b39edb3f45398c6515397816e6d)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
}

.result-item-box {
  
  border-radius: 11px;
  position: relative;
  width: 1107px;

  margin: 0 auto 54px;
}

.box_5 {
  border-radius: 14px;
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/4b74fc1d96b049a6bc974775d5e39def_mergeImage.png);
  height: 542px;
  width: 1388px;
  margin: 44px 0 0 44px;
}

.order-bar-wrap {
  box-shadow: 11px 24px 38px 0px rgba(0, 51, 102, 0.06);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 11px;

  height: 127px;
  margin: 0;
  padding: 24px;
  justify-content: space-between;
}

.start-finished-wrap {
  margin: 14px 0 0;
}

.text_13 {
  width: 65px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
}

.start-pointer {
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 22px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 31px;
}

.group_7 {
  width: 193px;
  height: 95px;
  margin: 39px 0 0 5px;
}

.text_15 {
  width: auto;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 23px;
  margin-left: 8px;
}

.section_10 {
  width: 159px;
  height: 41px;
  margin-top: 25px;
}

.arrow-icon {
  width: 51px;
  height: 9px;
  background: url(~/assets/arrow-right-gray.png)
    0px -1px no-repeat;
  background-size: 51px 10px;
  margin: 9px 14px 0;
}

.finished-pointer {
  width: auto;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 22px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 31px;
}

.order-bar-right-info {
}

.text_17 {
  min-width: 65px;
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(44, 46, 45, 1);
  font-size: 22px;
  font-family: PingFangHK-Semibold;
  text-align: right;
  white-space: nowrap;
  line-height: 31px;
  margin-left: 111px;
}

.text_18 {
 
  height: 31px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 22px;
  font-family: PingFangHK-Semibold;
  text-align: right;
  white-space: nowrap;
  line-height: 31px;
  margin-top: 7px;
}

.result-box-bar {
  width: auto;
  margin: 40px 40px 0;
}

.box_9 {
  width: 1px;
  height: 555px;
  margin-top: 24px;
}

.image-wrapper_1 {
  height: 138px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7c8acccc9324202caea51ce1410872b2d5be416e8ae25b9defd704f8db18c4c3)
    100% no-repeat;
  background-size: 100% 100%;
  width: 1px;
}

.image_1 {
  width: 1px;
  height: 138px;
}

.image_2 {
  width: 1px;
  height: 412px;
  margin-top: 5px;
}

.route-opt-list {
  padding: 61px;
  position: relative;
}
.route-opt-list::before {
  position: absolute;
  content: " ";
  width: 1px;
  top: 80px;
  bottom: 118px;
  left: 41px;
  background: #bdbdbd;
}
.route-opt-item {
  position: relative;
  margin-bottom: 35px;
}
.route-opt-item::before {
  position: absolute;
  content: " ";
  width: 14px;
  height: 14px;
  border-radius: 100%;
  background: #fc6f34;

  left: -27px;
  top: 17px;
}
.route-opt {
  height: 24px;
}

.route-opt-label {
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 25px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
}

.route-opt-time {
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 16px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 7px;
}

.text-route-opt-info-wrap {
  overflow-wrap: break-word;
  font-size: 0;
  font-family: PingFangHK-Regular;
  text-align: left;
  line-height: 24px;
  color: rgba(51, 51, 51, 1);
  margin-top: 3px;
  font-size: 16px;
}

.text_22 {
  width: 1352px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 22px;
  text-align: left;
  line-height: 32px;
}

.text_23 {
  width: 1352px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  line-height: 32px;
}

.text-wrapper_7 {
  width: 242px;
  height: 32px;
  margin-top: 47px;
}

.text_24 {
  width: 76px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 25px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
}

.text_25 {
  width: 152px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
}

.text_26 {
  width: 1129px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(189, 189, 189, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
  margin-top: 4px;
}

.box_11 {
  width: 302px;
  height: 68px;
  margin-top: 47px;
}

.text-group_5 {
  width: 302px;
  height: 68px;
}

.text_27 {
  width: 76px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 25px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
}

.text_28 {
  width: 302px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(189, 189, 189, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
  margin-top: 4px;
}

.text_29 {
  width: 128px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 0 85px 0 -212px;
}

.text-group_6 {
  width: 583px;
  height: 158px;
  margin-top: 26px;
}

.text_30 {
  width: 583px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(189, 189, 189, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  line-height: 32px;
}

.text_31 {
  width: 302px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(189, 189, 189, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  line-height: 32px;
  margin-top: 29px;
}

.box_12 {
  width: 302px;
  height: 77px;
  margin-top: 46px;
}

.text-group_7 {
  width: 302px;
  height: 77px;
}

.text_32 {
  width: 76px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 25px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
}

.text_33 {
  width: 302px;
  height: 32px;
  overflow-wrap: break-word;
  color: rgba(189, 189, 189, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
  margin-top: 13px;
}

.text_34 {
  width: 128px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(119, 120, 122, 1);
  font-size: 22px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 0 85px 0 -212px;
}

.err-msg-wrap {
  background-color: rgba(239, 239, 239, 1);
  border-radius: 11px;
  height: 54px;
  width: auto;
  margin: 48px 40px 32px;
}

.err-msg-text {
  width: auto;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(231, 0, 18, 1);
  font-size: 14px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 19px;
  margin: 18px 0 0 27px;
}

.box_13 {
  background-color: rgba(252, 111, 52, 1);
  border-radius: 50%;
  position: absolute;
  left: 44px;
  top: 647px;
  width: 19px;
  height: 19px;
}

.box_14 {
  background-color: rgba(189, 189, 189, 1);
  border-radius: 50%;
  position: absolute;
  left: 44px;
  top: 795px;
  width: 19px;
  height: 19px;
}

.box_15 {
  background-color: rgba(189, 189, 189, 1);
  border-radius: 50%;
  position: absolute;
  left: 44px;
  top: 910px;
  width: 19px;
  height: 19px;
}

.box_16 {
  background-color: rgba(189, 189, 189, 1);
  border-radius: 50%;
  position: absolute;
  left: 47px;
  top: 1013px;
  width: 14px;
  height: 14px;
}

.box_17 {
  background-color: rgba(189, 189, 189, 1);
  border-radius: 50%;
  position: absolute;
  left: 47px;
  top: 1106px;
  width: 14px;
  height: 14px;
}

.box_18 {
  background-color: rgba(189, 189, 189, 1);
  border-radius: 50%;
  position: absolute;
  left: 44px;
  top: 1209px;
  width: 19px;
  height: 19px;
}

.section_11 {
  background-color: rgba(44, 46, 45, 1);
  height: 578px;
  margin-top: 38px;
  
}

 

.box_19 {
  width: 79px;
  height: 132px;
  margin-top: 5px;
}

.text_36 {
  width: 79px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text-group_8 {
  width: 72px;
  height: 65px;
  margin-top: 41px;
}

.text_37 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.text_38 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.text-wrapper_9 {
  width: 99px;
  height: 212px;
  margin: 5px 0 0 180px;
}

.text_39 {
  width: 99px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text_40 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 41px;
}

.text_41 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.text_42 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.text_43 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.box_20 {
  width: 99px;
  height: 172px;
  margin: 5px 0 0 180px;
}

.text_44 {
  width: 99px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text-group_9 {
  width: 72px;
  height: 104px;
  margin-top: 41px;
}

.text_45 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
}

.text_46 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.text_47 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-top: 14px;
}

.list_1 {
  width: 581px;
  height: 191px;
  margin-left: 224px;
  justify-content: space-between;
}

.list-items_1 {
  width: 144px;
  height: 191px;
  margin-right: 75px;
}

.block_7 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 7px;
  height: 144px;
  width: 144px;
}

.section_13 {
  width: 123px;
  height: 123px;
  background-size: 125px 125px;
  margin: 11px 0 0 10px;
}

.text_48 {
  width: 124px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 25px;
  margin: 22px 0 0 10px;
}

.box_21 {
  background-color: rgba(230, 230, 230, 1);
  border-radius: 34px;
  width: 68px;
  height: 138px;
  margin: 88px 0 0 49px;
}

.image-text_4 {
  width: 40px;
  height: 98px;
  margin: 19px 0 0 14px;
}

.box_22 {
  width: 40px;
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc0868cb18355c4fcfc99d80a8f8f42996969a64d913b24be44917ad3bfdda6b1)
    100% no-repeat;
  background-size: 100% 100%;
}

.text-group_10 {
  width: 36px;
  height: 50px;
  overflow-wrap: break-word;
  color: rgba(67, 67, 67, 1);
  font-size: 18px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  line-height: 25px;
  margin: 8px 0 0 2px;
}

.text-wrapper_10 {
  width: 347px;
  height: 27px;
  margin: 114px 0 113px 144px;
}

.text_49 {
  width: 79px;
  height: 27px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: PingFangHK-Semibold;
  text-align: left;
  white-space: nowrap;
  line-height: 27px;
}

.text_50 {
  width: 54px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 71px;
}

.text_51 {
  width: 72px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 18px;
  font-family: PingFangHK-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-left: 71px;
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
</style>
